














import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "PrivateLiveEndConfirm",
  components: { BaseConfirm, BaseButton },
  props: {
    show: { type: Boolean, default: false },
  },
});
